<template>
  <form id="create_channel_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن کانال</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>نام کانال(انگلیسی)</label>
          <input
            type="text"
            name="slug"
            v-model="form.slug"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>نام کانال</label>
          <input
            type="text"
            name="title"
            v-model="form.title"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>درباره کانال</label>
          <textarea
            name="about"
            v-model="form.about"
            class="form-control"
            rows="6"
          ></textarea>
        </div>
        <div class="form-group">
          <label>توضیحات کوتاه</label>
          <textarea
            name="description"
            v-model="form.description"
            class="form-control"
            rows="6"
          ></textarea>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { STORE_CHANNEL } from "@/core/services/store/channels.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { mapGetters } from "vuex";

export default {
  name: "channels-create",
  props: ["id"],
  data() {
    return {
      isCompany: this.$route.name.startsWith("company"),
      isAdmin: this.$route.name.startsWith("admin"),
      tinyMceOptions: {
        menubar: false,
        directionality: "rtl"
      },
      form: {
        slug: "",
        title: "",
        about: ""
      }
    };
  },
  mounted() {
    this.setBreadcrumbs();
    this.setActions();

    this.eventHub.$on("save-channel-event", this.save);

    this.fv = formValidation(document.getElementById("create_channel_form"), {
      fields: {
        title: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست"
            },
            stringLength: {
              min: 1,
              max: 128,
              message: "نام صحیح نیست"
            }
          }
        },
        slug: {
          validators: {
            notEmpty: {
              message: "نام انگلیسی صحیح نیست"
            },
            regexp: {
              regexp: /^(?!\d)(?!.*-.*-)(?!.*-$)(?!-)[a-zA-Z0-9-]{6,20}$/i,
              message: "نام انگلیسی صحیح نیست"
            },
            stringLength: {
              min: 1,
              max: 128,
              message: "نام انگلیسی صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off("save-channel-event");
    document.getElementById("save-channel-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["currentUserProperty", "channel"])
  },
  methods: {
    setBreadcrumbs() {
      let items = [];
      items.push({ title: "کانال‌ها", route: { name: "channels-index" } });
      items.push({ title: "افزودن" });

      this.$store.dispatch(SET_BREADCRUMB, items);
    },
    setActions() {
      let channelsRouteName = "channels-index";

      if (this.isCompany) {
        channelsRouteName = "company-channels-index";
      }

      this.$store.dispatch(SET_ACTIONS, {
        buttons: [
          {
            name: "ذخیره",
            event: "save-channel-event",
            class: "btn-primary",
            id: "save-channel-btn"
          }
        ],
        links: [
          {
            name: "بازگشت",
            to: { name: channelsRouteName }
          }
        ]
      });
    },
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-channel-btn");
          this.disableBtn(submitBtn);

          this.$store
            .dispatch(STORE_CHANNEL, this.form)
            .then(channel => {
              this.$router.push({
                name: "channels-show",
                params: { id: channel.id }
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
